/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PrimaryCategoryEnum } from './PrimaryCategoryEnum';
import {
    PrimaryCategoryEnumFromJSON,
    PrimaryCategoryEnumFromJSONTyped,
    PrimaryCategoryEnumToJSON,
    PrimaryCategoryEnumToJSONTyped,
} from './PrimaryCategoryEnum';

/**
 * Lightweight serializer for performer list views.
 * @export
 * @interface PerformerList
 */
export interface PerformerList {
    /**
     * 
     * @type {string}
     * @memberof PerformerList
     */
    readonly id: string;
    /**
     * Artist or band name (must be unique)
     * @type {string}
     * @memberof PerformerList
     */
    performerName: string;
    /**
     * 
     * @type {PrimaryCategoryEnum}
     * @memberof PerformerList
     */
    primaryCategory?: PrimaryCategoryEnum;
    /**
     * Searchable tags (e.g., "touring", "local", "established")
     * @type {Array<string>}
     * @memberof PerformerList
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PerformerList
     */
    readonly profileCompletion: string;
    /**
     * 
     * @type {string}
     * @memberof PerformerList
     */
    readonly mediaCount: string;
    /**
     * 
     * @type {boolean}
     * @memberof PerformerList
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PerformerList
     */
    readonly createdAt: Date;
}



/**
 * Check if a given object implements the PerformerList interface.
 */
export function instanceOfPerformerList(value: object): value is PerformerList {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('performerName' in value) || value['performerName'] === undefined) return false;
    if (!('profileCompletion' in value) || value['profileCompletion'] === undefined) return false;
    if (!('mediaCount' in value) || value['mediaCount'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function PerformerListFromJSON(json: any): PerformerList {
    return PerformerListFromJSONTyped(json, false);
}

export function PerformerListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PerformerList {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'performerName': json['performer_name'],
        'primaryCategory': json['primary_category'] == null ? undefined : PrimaryCategoryEnumFromJSON(json['primary_category']),
        'tags': json['tags'] == null ? undefined : json['tags'],
        'profileCompletion': json['profile_completion'],
        'mediaCount': json['media_count'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'createdAt': (new Date(json['created_at'])),
    };
}

  export function PerformerListToJSON(json: any): PerformerList {
      return PerformerListToJSONTyped(json, false);
  }

  export function PerformerListToJSONTyped(value?: Omit<PerformerList, 'id'|'profile_completion'|'media_count'|'created_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'performer_name': value['performerName'],
        'primary_category': PrimaryCategoryEnumToJSON(value['primaryCategory']),
        'tags': value['tags'],
        'is_active': value['isActive'],
    };
}

